import { useState } from "react";
import { Loader2, Users } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, errMsg } from "@/lib/api";
import { Field } from "@/components/common";
import { Face } from "@/components/connect/parts";

export default function NewChat({ base, people, canGroup, onClose, onOpen }) {
  const [group, setGroup] = useState(false);
  const [pick, setPick] = useState([]);
  const [name, setName] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const dm = async (p) => {
    try { const { data } = await api.post(`${base}/conversations/dm`, { key: p.key }); onOpen(data.id); } catch (e) { toast.error(errMsg(e)); }
  };
  const make = async (e) => {
    e.preventDefault();
    if (!name.trim()) return setErr("Give the group a name");
    if (pick.length < 2) return setErr("Pick at least 2 people");
    setBusy(true);
    try { const { data } = await api.post(`${base}/conversations/group`, { name, member_keys: pick }); onOpen(data.id); } catch (x) { setErr(errMsg(x)); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[90vh] overflow-y-auto sm:max-w-md" data-testid="new-chat-dialog">
        <DialogHeader><DialogTitle>{group ? "New group" : "New message"}</DialogTitle></DialogHeader>
        {canGroup && <button className="q-btn q-btn-secondary w-full" onClick={() => { setGroup(!group); setErr(""); }} data-testid="new-chat-group-toggle"><Users className="h-4 w-4" /> {group ? "Send a direct message instead" : "Make a group"}</button>}
        {group && <Field label="Group name" htmlFor="grp-name" error={err} errorTestid="new-group-error"><input id="grp-name" className="q-input" value={name} maxLength={40} onChange={(e) => { setName(e.target.value); setErr(""); }} data-testid="new-group-name-input" /></Field>}
        <ul className="space-y-1" data-testid="new-chat-people">
          {people.map((p) => {
            const on = pick.includes(p.key);
            const slug = p.name.split(" ")[0].toLowerCase();
            return (
              <li key={p.key}>
                <button type="button" onClick={() => (group ? setPick((x) => (on ? x.filter((k) => k !== p.key) : [...x, p.key])) : dm(p))} aria-pressed={group ? on : undefined}
                  className={`flex min-h-[52px] w-full items-center gap-3 rounded-xl px-3 text-left transition-colors duration-150 hover:bg-q-raised ${on ? "bg-q-raised ring-2 ring-[rgb(var(--glow-connect))]" : ""}`} data-testid={`new-chat-person-${slug}`}>
                  <Face p={p} size={36} /> <span className="font-semibold text-q-text">{p.name}</span>
                </button>
              </li>
            );
          })}
          {!people.length && <p className="text-sm text-q-muted" data-testid="new-chat-empty">No one to message yet.</p>}
        </ul>
        {group && <button className="q-btn q-btn-primary w-full" disabled={busy} onClick={make} data-testid="new-group-create-btn">{busy && <Loader2 className="h-4 w-4 animate-spin" />} Create group</button>}
      </DialogContent>
    </Dialog>
  );
}
